// extracted by mini-css-extract-plugin
export default {"section":"SlidesSection_section__f+2t5","title":"SlidesSection_title__P4BFE","slidesSection":"SlidesSection_slidesSection__QXDHO"};